import LiveEventService from '../../services/LiveEventService'
import router from '../../router'

const state = () => ({
    loadingLiveEvents: false,
    live_event: null,
    live_events: [],
    total: 0,
    pages: 0,
    page: 1,
})
  
const mutations = {
    SET_LIVE_EVENT: (state, payload) => {
        state.live_event = payload
    },
    SET_LIVE_EVENTS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.live_events = payload.itens
        }else{
            state.live_events = [...state.live_events, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_LIVE_EVENTS: (state, payload) => {
        state.loadingLiveEvent = payload
    },
}

const actions = {
    async fetchLiveEvent({commit}, id){
        try{
            commit('SET_LOADING_LIVE_EVENTS', true)
            const response = await LiveEventService.getOne(id);
            const data = response.data
            if(data){
                data.startDate = await formatarData(data.startDate);
                data.endDate = await formatarData(data.endDate);
                data.createdAt = await formatarData(data.createdAt);
                data.updatedAt = await formatarData(data.updatedAt);
            }
            commit('SET_LIVE_EVENT', response.data)
            commit('SET_LOADING_LIVE_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_LIVE_EVENTS', false);
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchLiveEvents({commit}, { keyword = '', pageNumber = 1, order = { name: 'ID', column: 'ID', sort: 'ASC' } }){
        try{
            commit('SET_LOADING_LIVE_EVENTS', true)
            const response = await LiveEventService.get(keyword, pageNumber, order);
            commit('SET_LIVE_EVENTS', response.data)
            commit('SET_LOADING_LIVE_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_LIVE_EVENTS', false);
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createLiveEvent({commit}, data){
        try{
            commit('SET_LOADING_LIVE_EVENTS', true)
            const response = await LiveEventService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            if(response) {
                router.push({path: `/form_live_event/${response.data.item.id}`});
            }
            commit('SET_SHOW_MODAL_CONFIRMATION', false)
            commit('SET_LOADING_LIVE_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_LIVE_EVENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeLiveEvent({commit}, data){
        try{
            commit('SET_LOADING_LIVE_EVENTS', true)
            const response = await LiveEventService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            if(response) {
                router.push({path: `/form_live_event/${response.data.item.id}`});
            }
            commit('SET_SHOW_MODAL_CONFIRMATION', false)
            commit('SET_LOADING_LIVE_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_LIVE_EVENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}
async function formatarData(dateString) {
  const date = new Date(dateString);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000); // converte para local
  return localDate.toISOString().slice(0, 16); // pega até YYYY-MM-DDTHH:MM
}

// async function formatarData(data) {
//     const dataObj = new Date(data);
//     const ano = dataObj.getUTCFullYear();
//     const mes = (dataObj.getUTCMonth() + 1).toString().padStart(2, '0');
//     const dia = dataObj.getUTCDate().toString().padStart(2, '0');
//     const hora = dataObj.getUTCHours().toString().padStart(2, '0');
//     const minuto = dataObj.getUTCMinutes().toString().padStart(2, '0');

//     return `${ano}-${mes}-${dia} ${hora}:${minuto}`;
// }

const getters = {
    getLiveEvent: state => state.live_event,
    getLiveEvents: state => state.live_events,
    getLoadingLiveEvent: state => state.loadingLiveEvent,
}

export default {
    state,
    getters,
    mutations,
    actions
};